import instance from "../../utils/axios";

export const toFormData = (obj) => {
  const formData = new FormData();
  for (const key in obj) {
    if (obj[key] !== undefined && obj[key] !== null) {
      formData.append(key, obj[key].toString()); // <-- important
    }
  }
  return formData;
};

const toUrlSearchParams = (payload) => {
  if (!payload) return new URLSearchParams();
  if (payload instanceof URLSearchParams) return payload;

  const params = new URLSearchParams();
  Object.keys(payload).forEach((key) => {
    const value = payload[key];
    if (value !== undefined && value !== null) {
      params.append(key, String(value));
    }
  });
  return params;
};

const post = async (path, payload, config) => {
  const res = await instance.post(path, payload, config);
  return res.data;
};



// ✅ Plan APIs
// planAPI.js (replace existing savePlan)
export const savePlan = async (payload) => {
  const params = toUrlSearchParams(payload);
  return post("/plans/save", params, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
};




// export const updatePlan = async (payload) => instance.post("/plans/update", toFormData(payload)).then(res => res.data);
export const updatePlan = async (payload) => {
  const params = toUrlSearchParams(payload);
  return post("/plans/update", params, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
};

export const deletePlan = async (payload) => post("/plans/delete", toUrlSearchParams(payload));
export const readPlan = async (payload) => post("/plans/read", toFormData(payload));
export const readPlanCategories = async (payload) => post("/planCategories/read", toUrlSearchParams(payload));
export const savePlanCategory = async (payload) => post("/planCategories/save", toUrlSearchParams(payload));

// ✅ Day Plan APIs
// export const saveDayPlan = async (payload) => instance.post("/plans/dayplans/save", toFormData(payload)).then(res => res.data);
// export const updateDayPlan = async (payload) => instance.post("/plans/dayplans/update", toFormData(payload)).then(res => res.data);
// export const deleteDayPlan = async (payload) => instance.post("/plans/dayplans/delete", new URLSearchParams(payload)).then(res => res.data);
// export const readDayPlan = async (payload) => instance.post("/plans/dayplans/read", toFormData(payload)).then(res => res.data);
// ✅ Day Plan APIs — SAFE WITH YOUR INSTANCE
export const saveDayPlan = async (payload) => {
  const params = toUrlSearchParams(payload);
  return post("/plans/dayplans/save", params);
};

export const updateDayPlan = async (payload) => {
  const params = toUrlSearchParams(payload);
  return post("/plans/dayplans/update", params);
};

export const readDayPlan = async (payload) => {
  return post("/plans/dayplans/read", toUrlSearchParams(payload));
};

export const deleteDayPlan = async (payload) => {
  return post("/plans/dayplans/delete", toUrlSearchParams(payload));
};
export const saveDayPlanDetail = async (payload) => {
  const params = toUrlSearchParams(payload);
  return post("/plans/dayplans/details/save", params);
};

export const updateDayPlanDetail = async (payload) => {
  const params = toUrlSearchParams(payload);
  return post("/plans/dayplans/details/update", params);
};

// planAPI.js - Add this function
export const deleteDayPlanDetail = async (payload) => {
  const params = toUrlSearchParams(payload);
  return post("/plans/dayplans/details/delete", params);
};

export const readTWGPlans = async (payload) => {
  const params = toUrlSearchParams(payload);
  return post("/plans/twg", params, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
};

// ✅ Plan Link APIs
export const savePlanLink = async (payload) => post("/planlinks/save", payload);
export const updatePlanLink = async (payload) => post("/planlinks/update", payload);
export const deletePlanLink = async (payload) => post("/planlinks/delete", payload);
export const readPlanLink = async (payload) => post("/planlinks/read", payload);
